import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';

import placeholder from 'lib/placeholder';

import Stepper from './Stepper';
import StepLabel from './Stepper/StepLabel';
import { useStepper } from './Stepper/StepperProvider';

const FormSteps = forwardRef(({ className, ...rest }, ref) => {
  const { activeStep, steps } = useStepper();

  return (
    <Box ref={ref} className={twMerge('p-4', className)} {...rest}>
      <Heading as="h2" className="mb-3" size="size6">
        {placeholder('titles.formSteps')}
      </Heading>
      <Stepper
        activeStep={activeStep}
        className="space-y-3"
        render={({ control, step }) => (
          <StepLabel {...control}>{step}</StepLabel>
        )}
        steps={steps}
      />
    </Box>
  );
});

FormSteps.displayName = 'SuggestNewOfferSteps';

FormSteps.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default FormSteps;
